import type { Command } from "../types/command.types";

export const getLongExposedId = (command: Command) => {
	const exposedId = command.exposedId;
	if (exposedId) {
		const tokens = exposedId.split("-");
		if (tokens.length !== 3) {
			return exposedId;
		}
		const { firstName, lastName } = command.patient ?? {};
		if (firstName && lastName) {
			return `${exposedId}-${lastName.toLowerCase()}-${firstName.toLowerCase()}`;
		}
		return exposedId;
	}
	return exposedId;
};

export const getTicketCommandId = (command: Command) => {
	return getLongExposedId(command);
};
